import AppLoading from 'containers/App/AppLoading'
import AppTheme from 'containers/App/AppTheme'
import { useEffect } from 'react'

function ExternalUrlRedirect({ url }) {
  useEffect(() => {
    window.location.href = url
  }, [url])

  return (
    <AppTheme>
      <AppLoading />
    </AppTheme>
  )
}

export default ExternalUrlRedirect
